import styled from 'styled-components';
import { getPropOrElse, getColorShade } from '../../../src/styled/utils';
const MEDIUM_SIZE = 20;
const widthMap = new Map([
    ['small', 16],
    ['medium', MEDIUM_SIZE],
    ['large', 24],
    ['xlarge', 36]
]);
const getSize = ({ $size }) => {
    if (typeof $size === 'number')
        return Math.abs($size);
    return widthMap.get($size) || MEDIUM_SIZE;
};
export const StyledIcon = styled.svg `
  display: inline-block;
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  color: ${getPropOrElse(['$color'], getColorShade('onSurface', 'mediumEmphasis'))};
  font-size: ${getSize}px;
  fill: currentcolor;

  & path {
    fill: ${getPropOrElse(['$color'], getColorShade('onSurface', 'mediumEmphasis'))};
    fill-opacity: 1;
  }
`;
